import { render } from "./shopMoney.vue?vue&type=template&id=5cb3487b&scoped=true"
import script from "./shopMoney.vue?vue&type=script&lang=js"
export * from "./shopMoney.vue?vue&type=script&lang=js"

import "./shopMoney.vue?vue&type=style&index=0&id=5cb3487b&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb3487b"]])

export default __exports__